import * as React from 'react';
export const certificateSvg = React.forwardRef(function certificateSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.02.42a1.447 1.447 0 0 0-2.04 0l-.842.852H4.954a1.44 1.44 0 0 0-1.441 1.44v1.192l-.839.828-.003.003a1.446 1.446 0 0 0 0 2.04l.842.841v1.182c0 .796.646 1.44 1.44 1.44h1.195l.843.842c.56.56 1.478.56 2.04 0l.841-.842h1.195a1.44 1.44 0 0 0 1.44-1.44V7.595l.822-.82a1.446 1.446 0 0 0 0-2.04l-.842-.84V2.701a1.44 1.44 0 0 0-1.44-1.44H9.861L9.02.42ZM7.185 2.347 8 1.522l.815.814c.274.274.64.426 1.025.426h1.147v1.155c0 .385.152.751.426 1.025l.814.813-.824.824-.01.011c-.24.26-.4.619-.385 1.02v1.128H9.85c-.386 0-.751.152-1.025.426l-.816.814-.815-.814a1.445 1.445 0 0 0-1.025-.426H5.013V7.593c0-.369-.148-.747-.426-1.024l-.814-.814.822-.811.011-.012a1.46 1.46 0 0 0 .407-1.005V2.772H6.16c.385 0 .75-.152 1.025-.425Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.25 12.25a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.015.702l3.23-1.218 3.241 1.218a.75.75 0 0 0 1.014-.702v-3a.75.75 0 0 0-1.5 0v1.917l-2.491-.936a.75.75 0 0 0-.528 0l-2.481.935V12.25Z',
    }),
  );
});
certificateSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var certificate = {
  category: 'icon',
  colorable: true,
  name: 'certificate',
  svg: certificateSvg,
};
